export default {
    LOAD_INFO_COMPANY: "LOAD_INFO_COMPANY",
    ADD_INFO_COMPANY: "ADD_INFO_COMPANY",
    CLEAR_INFO_COMPANY: "CLEAR_INFO_COMPANY",
    REMEMBER_COMPANY: "REMEMBER_COMPANY"
}